import { NavigationExtras, Router } from '@angular/router';

export const PARAM_TOKEN = null;

export abstract class NavigatorBase {
  fixPath(path: any[]): any[] {
    if (path.length > 0 && typeof path[0] == 'string') {
      const s: string = path[0];
      if (!s.startsWith('/')) {
        path[0] = `/${s}`;
      }
    }
    return path;
  }
}

export class Navigator extends NavigatorBase {
  private path: any[];

  constructor(private router: Router, ...path: any[]) {
    super();
    this.path = this.fixPath(path);
  }

  navigate(extras?: NavigationExtras) {
    return this.router.navigate(this.path, extras);
  }
}

export class NavigatorWithParam<T> extends NavigatorBase {
  private path: any[];

  constructor(private router: Router, ...path: any[]) {
    super();
    this.path = this.fixPath(path);
  }

  navigate(value: T, extras?: NavigationExtras) {
    const fullpath = [...this.path];
    if (fullpath.some(part => part === PARAM_TOKEN)) {
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value);
    } else {
      fullpath.push(value);
    }
    return this.router.navigate(fullpath, extras);
  }


  navigate2(value: T, outlets) {
    const fullpath = [...this.path];
    if (fullpath.some(part => part === PARAM_TOKEN)) {
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value);
      return this.router.navigate([...fullpath], outlets);
    } else {
      return this.router.navigate([...fullpath, value], outlets);
    }
  }
}

export class NavigatorWith2Params<T, U> extends NavigatorBase {
  private path: any[];

  constructor(private router: Router, ...path: any[]) {
    super();
    this.path = this.fixPath(path);
  }

  navigate(value1: T, value2: U) {
    const fullpath = [...this.path];
    if (fullpath.some(part => part === PARAM_TOKEN)) {
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value1);
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value2);
      return this.router.navigate([...fullpath]);
    } else {
      return this.router.navigate([...fullpath, value1, value2]);
    }
  }

  navigate2(value1: T, value2: U, outlets) {
    const fullpath = [...this.path];
    if (fullpath.some(part => part === PARAM_TOKEN)) {
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value1);
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value2);
      return this.router.navigate([...fullpath], outlets);
    } else {
      return this.router.navigate([...fullpath, value1, value2], outlets);
    }
  }
}
